import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

export const useAllowPickupOrderFeature = () => {
  const { data: loggedUser } = useCurrentUser()
  return loggedUser?.permissions?.Admin || loggedUser?.UserAttributes['custom:warehouse'] === PkgWarehouse.UK
}
